import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface SmsConsentCheckboxesProps {
  transactional: boolean;
  marketing: boolean;
  onTransactionalChange: (value: boolean) => void;
  onMarketingChange: (value: boolean) => void;
  idPrefix?: string;
}

const SmsConsentCheckboxes = ({
  transactional,
  marketing,
  onTransactionalChange,
  onMarketingChange,
  idPrefix = "sms",
}: SmsConsentCheckboxesProps) => {
  return (
    <div className="space-y-4 border-t border-border pt-6">
      <div className="flex items-start gap-3">
        <Checkbox
          id={`${idPrefix}-transactional-consent`}
          checked={transactional}
          onCheckedChange={(checked) => onTransactionalChange(checked === true)}
          className="mt-1"
        />
        <Label
          htmlFor={`${idPrefix}-transactional-consent`}
          className="text-sm font-normal leading-relaxed cursor-pointer text-muted-foreground"
        >
          By checking this box, I consent to receive transactional text messages from Routine
          Cleaners related to my quote, appointments and service updates. Message frequency may
          vary. Message &amp; data rates may apply. Reply HELP for help or STOP to opt out.
        </Label>
      </div>

      <div className="flex items-start gap-3">
        <Checkbox
          id={`${idPrefix}-marketing-consent`}
          checked={marketing}
          onCheckedChange={(checked) => onMarketingChange(checked === true)}
          className="mt-1"
        />
        <Label
          htmlFor={`${idPrefix}-marketing-consent`}
          className="text-sm font-normal leading-relaxed cursor-pointer text-muted-foreground"
        >
          By checking this box, I consent to receive marketing and promotional text messages from
          Routine Cleaners, including special offers and discounts. Message frequency may vary.
          Message &amp; data rates may apply. Reply HELP for help or STOP to opt out.
        </Label>
      </div>

      <p className="text-xs text-muted-foreground">
        These options are not required to submit this form. See our{" "}
        <a href="/privacy-policy" className="text-accent hover:underline font-medium">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="/terms-and-conditions" className="text-accent hover:underline font-medium">
          Terms and Conditions
        </a>
        .
      </p>
    </div>
  );
};

export default SmsConsentCheckboxes;
